var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "features-section" }, [
    _c("h2", [_vm._v("What's in Premium?")]),
    _vm._v(" "),
    _c("div", { staticClass: "features" }, [
      _c("div", { staticClass: "features-column free" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "unstyled free" },
          _vm._l(_vm.features, function(feature) {
            return _c(
              "li",
              { key: feature.text, class: { disabled: feature.premium } },
              [
                _c("span", [
                  _vm._v(
                    "\n            " + _vm._s(feature.text) + "\n            "
                  ),
                  feature.premium
                    ? _c("em", {
                        staticClass: "b-sprite-paywall-pix-blank-check"
                      })
                    : _c("em", {
                        staticClass: "b-sprite-paywall-pix-checkmark-gray"
                      })
                ]),
                _vm._v(" "),
                feature.subfeatures
                  ? _c(
                      "ul",
                      { staticClass: "unstyled" },
                      _vm._l(feature.subfeatures, function(subfeature) {
                        return _c(
                          "li",
                          {
                            key: subfeature.text,
                            class: { disabled: subfeature.premium }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(subfeature.text) +
                                  "\n                "
                              ),
                              subfeature.premium
                                ? _c("em", {
                                    staticClass:
                                      "b-sprite-paywall-pix-blank-check"
                                  })
                                : _c("em", {
                                    staticClass:
                                      "b-sprite-paywall-pix-checkmark-gray"
                                  })
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "features-column premium col" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "unstyled" },
          _vm._l(_vm.features, function(feature) {
            return _c("li", { key: feature.text }, [
              _c("span", [
                _vm._v(
                  "\n            " + _vm._s(feature.text) + "\n            "
                ),
                _c("em", { staticClass: "b-sprite-paywall-pix-checkmark" })
              ]),
              _vm._v(" "),
              feature.subfeatures
                ? _c(
                    "ul",
                    { staticClass: "unstyled" },
                    _vm._l(feature.subfeatures, function(subfeature) {
                      return _c("li", { key: subfeature.text }, [
                        _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(subfeature.text) +
                              "\n                "
                          ),
                          _c("em", {
                            staticClass: "b-sprite-paywall-pix-checkmark"
                          })
                        ])
                      ])
                    }),
                    0
                  )
                : _vm._e()
            ])
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("div", { staticClass: "icon" }, [
        _c("span", { staticClass: "b-sprite-paywall-pix-hydrogen" })
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("Free")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Try a free preview of each course and new Daily Challenges in the Today tab."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("div", { staticClass: "icon" }, [
        _c("span", { staticClass: "b-sprite-paywall-pix-carbon-sparkle" })
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("Premium")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Unlock all courses and Daily Challenges on Brilliant to supercharge your learning."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }